exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination-display {\n  text-align: left;\n  display: table-cell; }\n\n.per-page-dropdown {\n  display: table-cell;\n  min-width: 65px;\n  vertical-align: middle;\n  padding-left: 10px; }\n\n.paging-controls {\n  display: table; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/paged-list.scss
// module id = 1238
// module chunks = 0